var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"appear":""}},[_c('VIcon',{class:_vm.$style.loadingIcon,attrs:{"name":"sync","spin":""}}),_c('VProgressCircular',{attrs:{"indeterminate":false,"rotate":true,"size":32,"value":"","width":4,"color":"light-blue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }